import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../../theme';
import { borderRadius } from '../../../styles/mixins';

export const useSectionHeaderStyles = createStyles(({ token }) => ({
  quoteHeader: {
    backgroundColor: ThemeColors.COLOR_GREY_BLUISH,
    padding: `3px ${ThemeSpaces.SPACE_NORM}px`,
    boxShadow: `-6px -6px 15px ${token.colorWhite}`,
    ...borderRadius({ size: token.borderRadiusSM }),
    fontWeight: 500,
    color: token.colorWhite,
    marginBottom: ThemeSpaces.SPACE_MD,

    'h4.ant-typography': {
      fontSize: token.fontSize,
      color: token.colorWhite,
      marginBottom: 0,
    },
  },
}));
